module.exports = __webpack_public_path__ + "static/media/crash.3d3ba5cb.png";